// extracted by mini-css-extract-plugin
export default {"buttonsModal":"buttonsModal-s1rgd","button":"button-YNnsK"};